const create_ticket_require_field: any = {
  updateChangeRoleAdmin: ['new_role', 'current_role', 'username'],
  checkBetSettled: [
    'username',
    'user_alias',
    'settle_value',
    'provider_name',
    'operator_name',
    'game_id',
  ],
  changeBankAccountName: [
    'current_bank_account_name',
    'current_bank_name',
    'operator_name',
    'username'
  ],
  changeUsername: ['username', 'operator_name', 'new_telephone_number'],
  inactiveUserAdmin: ['reason', 'username'],
  createNewUserAdmin: [
    'role',
    'operator_name',
    'new_admin_name',
    'operator_list'
  ],
  changeBankAccountNo: [
    'current_bank_account_name',
    'current_account_no',
    'current_bank_name',
    'new_bank_account_name',
    'new_account_no',
    'new_bank_name',
    'operator_name'
  ],
  betNotSettled: [
    'username',
    'user_alias',
    'provider_name',
    'game_id',
    'operator_name'
  ],
  addRemoveOperationList: ['operator_name', 'username', 'issue_type', 'operator_list'],
  updateLineOa: [ 'new_link_line_oa', 'operator_name'],
  cantPlaygame: [
    'operator_name',
    'provider_name',
    'username',
  ],
  checkCommissionAffiliate: ['date_for_check', 'operator_name', 'bank_account_name', 'bank_account_no', 'bank_name', 'username', 'mobile', 'issue_type', 'amount'],
  clearHoldBalance: ['bank_account_name', 'bank_account_no', 'bank_name', 'username', 'mobile', 'operator_name', 'payment_gateway', 'date_for_check', 'total_hold_balance'],
  requestChangeUsernamePasswordAdmin: ['reason', 'username'],
  adminRequestResetgoogleAuth: ['reason', 'username'],
  adminRequestResetMobileNo: ['reason', 'username'],
  cantUseCms: [ 'title', 'username', 'issueDetails'],
  updateWithdrawLimit: [ 'username', 'type', 'amount'],
  updateValidBalance: [ 'username', 'type', 'amount'],
  loyaltyPoint: [ 'bank_account_name', 'bank_account_no', 'bank_name', 'username', 'mobile', 'issue_type', 'loyalty_point_amount'],
  depositAndWithdrawnCms: [ 'bank_account_name', 'bank_account_no', 'bank_name', 'username', 'mobile', 'issue_type', 'payment_gateway', 'date_time', 'amount'],
  other: ['issueDetails'],
}

export const check_require_field = (form_name: string, formData: FormData) => {
  const form = create_ticket_require_field[form_name]

  const missing_field: string[] = []
  for (const field of form) {
    if (!formData.has(field) || formData.get(`${field}`) == '') missing_field.push(field)
  }
  if (missing_field.length) {
    return { validated: false, missing_field }
  } else {
    return { validated: true, missing_field }
  }
}
